export default "__VITE_ASSET__Cz$gPX5e__"